module.exports = __webpack_public_path__ + "static/img/041005.98232088.png";